import script from "./authorization_cmp.vue?vue&type=script&setup=true&lang=js"
export * from "./authorization_cmp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__